<template>
  <div data-testid="checkout-div-379" v-if="$context.is.edu" v-html="$t('billing.common.learn_more_about_edu')" @click="clickHandler($event)"></div>
</template>

<script>
import { ZOOM_METTING_EDU_I18N_TITLE_KEY } from '@/plans/ZOOM_MEETING/common/utils';
export default {
  name: 'EduTips',
  methods: {
    clickHandler(e) {
      if (e.target.tagName === 'A') {
        this.$tracking.buyInteraction(
          `${this.$t(ZOOM_METTING_EDU_I18N_TITLE_KEY)} options`,
          'learn more about zoom education eligibility requirements'
        );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
div {
  margin: 32px 0;
  color: #515079;
  font-family: 'Almaden Sans';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  a {
    color: #0B5CFF;
  }
}
</style>
